document.addEventListener('DOMContentLoaded', function() {

	const form = document.getElementById('bundle-form');
	if (!form) return;

	const totalPriceDisplay = document.getElementById('bundle-total-price');

	function formatMoney(amountCents) {
		return (amountCents / 100).toLocaleString('ro-RO', {
			style: 'currency',
			currency: 'RON'
		});
	}

	function updateBundleTotal() {
		const bundleCheckboxes = form.querySelectorAll('input[name="bundle-product"]');
		let totalPrice = 0;

		bundleCheckboxes.forEach(cb => {
			if (cb.checked) {
				const priceInt = parseInt(cb.dataset.price, 10);
				if (!isNaN(priceInt)) {
					totalPrice += priceInt;
				}
			}
		});

		if (totalPriceDisplay) {
			totalPriceDisplay.innerHTML = 'Total: ' + formatMoney(totalPrice);

			if (totalPrice >= 14000) {
				totalPriceDisplay.innerHTML += '<p class="bundle-total-price-free-shipping">Beneficiezi de transport gratuit!</p>';
			}
		}
	}

	function renderRandomFromCollection(collectionName, targetId) {
		const items = window.bundleProducts && window.bundleProducts[collectionName];
		if (!items || items.length === 0) return;

		const product = items[Math.floor(Math.random() * items.length)];

		let priceHtml = '';
		if (product.comparePrice && product.comparePrice > product.price) {
			priceHtml = `
        <p class="product-price">
          <span class="reduced-price">${product.priceMoney}</span>
          <span class="compare-at-price">
            <s>${(product.comparePrice / 100).toLocaleString('ro-RO', { style: 'currency', currency: 'RON' })}</s>
          </span>
        </p>
      `;
		} else {
			priceHtml = `<p class="product-price">${product.priceMoney}</p>`;
		}

		const checked_state = collectionName == 'lese' ? '' : 'checked';

		const html = `
			<div class="bundle-product">
				<label>
					<a href="/products/${product.handle}" target="_blank">
						<img class="bundle-product-image" width="100px" height="100px" src="${product.img}" alt="${product.title}">
					</a>
					<div class="bundle-product-description">
						<a href="/products/${product.handle}" target="_blank"><p class="product-title">${product.title}</p></a>
						${priceHtml}
					</div>
					<input type="checkbox" name="bundle-product" value="${product.variantId}" data-price="${product.price}" ${checked_state}>
				</label>
			</div>
		`;

		const target = document.getElementById(targetId);
		if (target) {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = html.trim();
			const newElement = tempDiv.firstElementChild;
			target.replaceWith(newElement);

			if (collectionName === 'zgarzi') {
				const checkbox = newElement.querySelector('input[name="bundle-product"]');
				const descriptionDiv = newElement.querySelector('.bundle-product-description');

				fetch(`/products/${product.handle}.js`)
					.then(res => res.json())
					.then(productData => {
						const select = document.createElement('select');
						select.id = 'bundle-zgarda-size';

						productData.variants.forEach(v => {
							const option = document.createElement('option');
							option.value = v.id;
							option.textContent = v.option1;
							select.appendChild(option);
						});

						descriptionDiv.appendChild(select);

						select.addEventListener('change', function() {
							const selectedVariant = select.value;
							if (checkbox) {
								checkbox.value = selectedVariant;
								const variantPrice = productData.variants.find(v => v.id == selectedVariant).price;
								checkbox.dataset.price = variantPrice;
								updateBundleTotal();
							}
						});

						select.value = product.variantId;
					})
					.catch(err => console.error('Eroare la preluarea variantelor zgardei:', err));
			}
		}
	}

	function attachCheckboxListeners() {
		const bundleCheckboxes = form.querySelectorAll('input[name="bundle-product"]');
		bundleCheckboxes.forEach(cb => {
			cb.addEventListener('change', updateBundleTotal);
		});
	}

	// BUNDLE 
	renderRandomFromCollection('lese', 'random-lese-container');
	renderRandomFromCollection('zgarzi', 'random-zgarzi-container');

	attachCheckboxListeners();
	updateBundleTotal();

	form.addEventListener('submit', function(e) {
		e.preventDefault();

		const bundleCheckboxes = form.querySelectorAll('input[name="bundle-product"]');
		const selectedVariantIds = Array.from(bundleCheckboxes)
			.filter(cb => cb.checked)
			.map(cb => parseInt(cb.value, 10))
			.filter(x => !isNaN(x));

		if (selectedVariantIds.length === 0) {
			alert('Selectează cel puțin un produs.');
			return;
		}

		const btn = form.querySelector('button.add-bundle');
		if (btn) {
			btn.disabled = true;
			var originalText = btn.textContent;
			btn.textContent = 'Se adaugă...';
		}

		const items = selectedVariantIds.map(id => ({
			id: Number(id),
			quantity: 1
		}));
		const giftVariantId = window.giftVariantId || 55235135373636;

		function addGiftToyIfMissing(callback) {
			fetch('/cart.js')
				.then(res => res.json())
				.then(cart => {
					const giftInCart = cart.items.some(item => item.id === giftVariantId);
					if (!giftInCart) {
						return fetch('/cart/add.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								items: [{
									id: giftVariantId,
									quantity: 1
								}]
							}),
						});
					}
				})
				.then(() => {
					if (typeof callback === 'function') callback();
				})
				.catch(err => {
					console.error('Eroare la adăugarea jucăriei cadou', err);
					if (typeof callback === 'function') callback();
				});
		}

		fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					items
				}),
			})
			.then(res => {
				if (!res.ok) throw new Error('Eroare la adăugare');
				return res.json();
			})
			.then(() => {
				return fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						attributes: {
							"BundleProducts": selectedVariantIds.join(',')
						}
					}),
				});
			})
			.then(() => {
				addGiftToyIfMissing(() => {
					window.location.href = '/cart';
				});
			})
			.catch(err => {
				console.error('Eroare la adăugarea bundle-ului sau a jucăriei cadou', err);

				const bundleSummary = document.querySelector('.custom-product-bundle .bundle-summary');
				if (bundleSummary) {
					const tempMsg = document.createElement('p');
					tempMsg.classList.add('warning-element');
					tempMsg.style.marginBottom = '10px';
					tempMsg.textContent = "Unul din produsele selectate nu mai are cantitate disponibilă.";
					bundleSummary.append(tempMsg);

					setTimeout(() => tempMsg.remove(), 4000);
				}

				if (btn) {
					btn.textContent = originalText;
					btn.disabled = false;
				}
			});
	});

	const bundleSelectedSizeSpan = document.getElementById('bundle-selected-size');
	const firstProductCheckbox = document.querySelector('.bundle-product.first-product input[type="checkbox"][name="bundle-product"]');

	const variantInput = document.querySelector('input#variant_id');

	if (variantInput) {
		variantInput.addEventListener('change', function() {
			const newVariantId = document.getElementById('variant_id');
			const newVariantSize = document.querySelector('legend.product-single__control-label span.variant_current');

			if (firstProductCheckbox) {
				firstProductCheckbox.value = newVariantId.value;
			}

			if (bundleSelectedSizeSpan) {
				bundleSelectedSizeSpan.textContent = newVariantSize.textContent;
			}

		});
	}

});
